import { defaultMobileMenuTheme } from '../MobileMenu'
import { defaultPostCardTheme } from '../PostCard'
import { defaultMobileDrawerTheme } from '../MobileDrawer'
import { defaultPhoneMeTheme } from '../PhoneMe'
import { defaultRealProjectCardTheme } from '../RealProjectCard'
import { defaultRealProductCardTheme } from '../RealProductCard'

export const defaultTheme = {
  MobileMenu: defaultMobileMenuTheme,
  PostCard: defaultPostCardTheme,
  RealProjectCard: defaultRealProjectCardTheme,
  RealProductCard: defaultRealProductCardTheme,
  MobileDrawer: defaultMobileDrawerTheme,
  Breadcrumbs: {
    root: 'mw8 center mt5 mt3-l pt2 pt3-m pt0-l pb2 ph2 ph4-m',
    item: 'f6 fw4',
    link: 'silver hover-rc',
    separator: 'mh2',
  },
  RouteBreadcrumbs: {
    root: 'mt5 mt3-l pt2 pt3-m pt0-l',
  },
  SocialShare: {
    root: 'flex pa2',
    itemWrapper: 'mr2',
  },
  TagList: {
    item: 'dib mr2 mb2 dark-blue f6 i',
  },
  Form: {
    submitButton: 'ph4 pv3 pointer pf f6 f5-ns fw9 white ttu bn outline-0',
    submitButtonSubmiting: 'bg-pc hover-bg-rc-dark',
    submitButtonNotSubmiting: 'bg-gray',
  },
  FormItem: {
    root: 'flex flex-column mb3',
    label: 'w-100 pv1',
    inputWrapper: 'w-100 pv2 ph0 bb b--gray',
    input: '',
    helpTextWrapper: 'pa2',
    helpText: 'f7 gray i',
    successTextWrapper: 'pa2',
    successText: 'f7 green',
    errorTextWrapper: 'pa2',
    errorText: 'f7 red',
  },
  Input: {
    input: 'w-100 bn db bg-transparent outline-0',
  },
  Textarea: {
    input: 'w-100 bn db bg-transparent outline-0',
  },
  Drawer: {
    root: 'fixed top-0 right-0 w-100 vh-100 bg-white z-999 db dn-l',
    closeButtonWrapper: 'right-0 top-0 absolute ph3 pv2 h3 flex items-center',
    closeButton:
      'pointer silver ba br-100 b--white w2 h2 flex items-center justify-center',
  },
  AttributeItems: {
    root: 'flex flex-wrap',
    label: 'w-50 pv1 bb b--light-gray fw7 f6',
    value: 'w-50 pv1 bb b--light-gray ml0 f6',
  },
  PhoneMe: defaultPhoneMeTheme,
  EntityContentWithStickyToc: {
    root: 'flex',
    // sidebar: 'w-100 ba b--gray b--dotted pa3 bg-light-gray',
    sidebar: 'dn db-l w-30-l bg-near-white ph2-l',
    sidebarContent: 'ph3-l',
    main: 'content w-100 w-70-l ph2 ph3-l pv3-l',
    drawer: {
      root:
        'fixed top-0 left-0 w-100 w-50-m w-third-l vh-100 bg-white z-999 pa2 pa3-ns',
      main: 'pt4',
      closeButtonWrapper: 'right-0 top-0 absolute ph3 pv2 h3 flex items-center',
      closeButton:
        'pointer silver ba br-100 b--white w2 h2 flex items-center justify-center',
    },
    toggleButton:
      'dn f2 pointer fixed bottom-2 right-2 bg-white br-100 w3 h3 items-center justify-center z-5 card-shadow',
  },
  Toc: {
    root: 'mt6-l',
    heading: 'ma0 lh-copy pt1 fw4 f6 f5-l',
    link: 'no-underline',
  },
}
